import customerInstance from '../../instance'

const updateDeliveryConfigPolygon = (id, data) => {
  return customerInstance.put('/deliveryPolygonConfigs/' + id, data)
}

export default updateDeliveryConfigPolygon
